import React from "react";

import { format } from "date-fns";

import { Box } from "@chakra-ui/react";

import { InfoPessoa } from "../Equipe/InfoPessoa";
import { Horarios } from "../Horarios";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";

export const Voluntariado = ({ data }) => {
  const columns = [
    {
      Header: "Atividades Desenvolvidas",
      accessor: "voluntariadoAtividades",
      Cell: (props) => {
        return (
          <span
            title={props.value}
            style={{
              wordBreak: "break-word",
            }}
          >
            {props.value}
          </span>
        );
      },
    },
    {
      Header: "Início das atividades",
      accessor: "dtInicioServico",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Data de Assinatura do Termo de Voluntariado",
      accessor: "dtAssinaturaTermo",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
  ];

  return data ? (
    <Box display="block">
      <Box className="break-page">
        <Group
          bgColor="#DDEBEA"
          title="Voluntariado"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          {data
            .sort((a, b) =>
              a.nomeVoluntariado.localeCompare(b.nomeVoluntariado, "pt-BR")
            )
            .map((voluntario, index) => (
              <Box key={index}>
                <InfoPessoa
                  name={voluntario.nomeVoluntariado}
                  data={[voluntario]}
                  columns={columns}
                />
                <Horarios horarios={voluntario.listaHorarios} />
              </Box>
            ))}
        </Group>
      </Box>
    </Box>
  ) : (
    <Box className="break-page">
      <Group
        bgColor="#DDEBEA"
        title="Voluntariado"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
